<template>
  <v-card class="mt-5">
    <v-card-title> Attribut radius pour le NAS </v-card-title>
    <v-card-text>
      <v-data-table
        class="table table-condensed table-striped"
        :loading="isLoading"
        hide-default-footer
        :items="attributes"
        :headers="headers"
        fixed-header
        dense
        disable-pagination
        disable-filtering
        locale="fr"
        sort-by="Value"
        must-sort
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import { useNas } from "@/composables/nas";

export default {
  props: {
    nas: Object,
  },
  setup(props) {
    const { nasData, showNasAttribute } = useNas();
    onMounted(() => {
      showNasAttribute(props.nas.id);
    });
    const headers = [
      { text: "Attribute", value: "Attribute" },
      { text: "Value", value: "Value" },
    ];
    return {
      ...toRefs(nasData),
      headers,
    };
  },
};
</script>
